<!-- 
Shows "not applicable" details for a bulk-levy collection provider task.
-->
<template>
  <div>
    <p v-if="showNotApplicableBreakdown" :class="'mb-1 ' + textColour">
      Not applicable to:
    </p>
    <ul v-if="showNotApplicableBreakdown" :class="'mb-2 ' + textColour">
      <li v-for="breakdown in task.notApplicableBreakdown" :key="breakdown.reason">
        {{ pluralise(breakdown.count) }} because {{ breakdown.reason }}
      </li>
    </ul>
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import taskMixins from "@/mixins/task.mixins";

export default {
  mixins: [lookupMixins, taskMixins],
  props: {
    task: {
      required: true,
      type: Object
    }
  },
  computed: {
    showNotApplicableBreakdown() {
      return this.task.notApplicableCount > 0;
    },
    textColour() {
      return this.getTextColour(this.task);
    }
  }
};
</script>
